<template>
<v-layout>
  <v-flex xs12
    md10 offset-md1
    lg8 offset-lg2
    xl6 offset-xl3
    :class="$vuetify.breakpoint.smAndUp ? 'pa-5' : 'px-2'"
  >
    <div v-if="easyLinkSuccess">
      <div slot="main-text">
        <p class="mt-4 mb-4 w title">
          Congratulations!
        </p>
      </div>
      <img
        :src="inspiration"
        height="150"
      />
      <div class="w subtitle-1" slot="secondary-text">
        <p class="mb-5">Your account with <strong>{{lender.nickName}}</strong> is now available.</p>
        <p class="mb-4 w title">Before you leave, remember to...</p>
        <ul class="next-steps grey--text text--darken-2">
          <li>Check your email for a Welcome invite from GreenSky, they will provide you with your login to their Customer Portal.</li>
          <li>Reach out to <strong>{{ dealerName }}</strong> and let them know they can get started on your home improvement project.</li>
          <li>Should you have any trouble with your GreenSky account, please call <strong>866-936-0602</strong>.</li>
        </ul>
        <br>
        <p>
          <!-- Typeform Consumer Feedback Survey -->
          <a class="typeform-share button" href="https://prod-research.typeform.com/to/GGSj1H" data-mode="popup" style="display:inline-block;text-decoration:none;background-color:#00012C;color:white;cursor:pointer;font-family:Helvetica,Arial,sans-serif;font-size:20px;line-height:50px;text-align:center;margin:0;height:50px;padding:0px 33px;border-radius:25px;max-width:100%;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;font-weight:bold;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;" target="_blank">Feedback?</a>
        </p>
      </div>
    </div>
    <div v-else>
      <div slot="main-text">
        <img
          :src="inspiration"
          height="200"
        />
        <p class="mb-5 w title">
          Don't give up!
        </p>
      </div>
      <div class="w subtitle-1" slot="secondary-text">
        <p class="mb-5">
          <span>Go ahead and contact <strong>{{dealerName}}</strong></span>
          <span v-if="dealerEmail" class="ml-1">at <a :href="`mailto:${dealerEmail}`" class="secondary--text">{{ dealerEmail }}</a></span>
          <span class="ml-1">to ask about other payment options they have prepared for you.</span>
        </p>
        <p class="mb-4 w title">
          What else can I do?
        </p>
        <p class="mb-5 pb-5">
          <ul class="next-steps">
            <li>try calling {{ lender.id }} at {{ lender.phoneNumber }}</li>
            <li>click on Easy Link again and have your other family member apply</li>
          </ul>
        </p>
        <p>
          <!-- Typeform Consumer Feedback Survey -->
          <a class="typeform-share button" href="https://prod-research.typeform.com/to/GGSj1H" data-mode="popup" style="display:inline-block;text-decoration:none;background-color:#00012C;color:white;cursor:pointer;font-family:Helvetica,Arial,sans-serif;font-size:20px;line-height:50px;text-align:center;margin:0;height:50px;padding:0px 33px;border-radius:25px;max-width:100%;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;font-weight:bold;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;" target="_blank">Feedback?</a>
        </p>
      </div>
    </div>
  </v-flex>
</v-layout>
</template>

<script>
  import { mapState } from 'vuex'

  export default {
    name: 'Inspirational',
    data() {
      return {
        inspiration: require('Assets/Inspiration.png'),
      }
    },
    computed: {
      ...mapState({
        applicantEmail: state => state.loanApplication.customerData.emailAddress,
        dealerName: state => state.user.companyName,
        dealerEmail: state => state.user.email,
        easyLinkSuccess: state => state.easyLink.success,
        lender: state => state.loanApplication.lender,
      }),
    },
    beforeMount() {
      const s = document.createElement('script')
      s.innerHTML = '(function() { var qs,js,q,s,d=document, gi=d.getElementById, ce=d.createElement, gt=d.getElementsByTagName, id="typef_orm_share", b="https://embed.typeform.com/"; if(!gi.call(d,id)){ js=ce.call(d,"script"); js.id=id; js.src=b+"embed.js"; q=gt.call(d,"script")[0]; q.parentNode.insertBefore(js,q) } })()'
      document.body.appendChild(s)
    },
  }
</script>

<style scoped>
.next-steps {
  max-width: 500px;
  margin: auto;
  text-align: left;
}

.next-steps li {
  margin-bottom: 15px;
  font-size: 18px!important;
}
</style>

